import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { replaceWithDataSource } from "../helpers/variable";
import { H2RButton } from "../../imports";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RSelect
				selected={cue.mode}
				label="Mode"
				options={[
					{
						label: "Gap between each loop",
						value: "await",
					},
					{
						label: "Endless loop",
						value: "chain",
					},
					// {
					// 	name: "Smooth",
					// 	value: "smooth",
					// },
				]}
				onChange={(value) => {
					return onUpdate({ mode: value });
				}}
			/>
			<H2RSelect
				selected={cue.speed || "5"}
				label="Speed"
				options={[
					{
						label: "Slow",
						value: "5",
					},
					{
						label: "Medium",
						value: "10",
					},
					{
						label: "Fast",
						value: "15",
					},
					{
						label: "Really fast",
						value: "20",
					},
				]}
				onChange={(value) => {
					return onUpdate({ speed: value });
				}}
			/>
			<H2RInput
				label="Ticker title (Large text)"
				value={cue.title}
				onChange={(value) => {
					onUpdate({
						title: value,
					});
				}}
			/>
			{cue.items.length < 1 && (
				<span className="mt-6 text-gray-600 text-sm">
					No ticker items added
				</span>
			)}
			{cue.items.map((item, index) => {
				return (
					<div key={`${index}_${cue.items.length + 1}`}>
						<div className="pt-2 flex items-end space-x-2">
							<H2RInput
								label={`Item ${index + 1} (Small text)`}
								value={item.body}
								onChange={(value) => {
									let val = value;
									onUpdate({
										items: [
											...cue.items.map((it, id) => {
												if (id === index) {
													return {
														...it,
														body: val,
													};
												} else {
													return {
														...it,
														body: it.body,
													};
												}
											}),
										],
									});
								}}
							/>
							<H2RButton
								type="link"
								text=""
								icon={faClose}
								size="small"
								css="w-min"
								colour="dark"
								onClick={() => {
									let newArray = Array.from(cue.items);

									newArray.splice(index, 1);

									// return console.log(index, newArray);
									return onUpdate({ items: [...newArray] });
								}}
							/>
						</div>
					</div>
				);
			})}
			<H2RButton
				text="Add item"
				icon={faPlus}
				size="small"
				colour="dark"
				onClick={() => {
					onUpdate({
						items: [
							...cue.items,
							{
								title: "Item",
								body: "Body text",
							},
						],
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg  overflow-hidden">
			<span className="font-semibold">
				{replaceWithDataSource(cue.title, dynamicText, dynamicLists, true) || "Ticker title"}
			</span>
		</div>
	);
};
